<template>
  <div class="lesson">
    <!--<above-nav></above-nav>-->
    <!--<side-nav></side-nav>-->
    <nav class="top-nav">
      <!--<button class="new-lesson"-->
              <!--@click="showCreateLesson"-->
              <!--v-if="schoolNow.iscreator===1||schoolNow.ismanager===1">-->
        <!--{{$t('m.cou_n_new_course')}}-->
      <!--</button>-->
      <button class="new-lesson"
              @click="showCreateLesson">
        {{$t('m.cou_n_new_course')}}
      </button>
    </nav>
    <div class="content-wrapper">
      <lesson-list :list="lessonList"></lesson-list>
      <template v-if="!isEmpty(lessonList)&&(totalPage>8)">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="8"
          :total="totalPage">
        </el-pagination>
      </template>
    </div>
    <div class="lessonpop-mask" v-if="newLessonShow">
      <div class="lessonpop">
        <h2 class="title">{{$t('m.cou_n_new_course')}}</h2>
        <p class="row">
          <span class="left">{{$t('m.cou_n_course_title')}}</span>
          <input type="text"
                 class="input-name"
                 v-model="lessonname"
                 :placeholder="$t('m.cou_n_course_input_title')"
                 maxlength="20">
        </p>
        <p class="row">
          <span class="left">{{$t('m.cou_n_course_type')}}</span>
          <el-cascader
            :options="firstType"
            v-model="selectedOptions"
            :placeholder="$t('m.select')"
            size="small"
            @change="handleCoverChange">
          </el-cascader>
        </p>
        <div class="cover-row">
          <span class="left">{{$t('m.cou_n_course_cover')}}</span>
          <span class="right">
            <span class="img-wrapper" @click="queryCoverList">
              <img class="img" :src="imgurl" alt="cover" width="150" height="100">
            </span>
            <div class="upload-button-wrapper">
              <!--<vue-core-image-upload-->
              <!--class="upload-button"-->
              <!--crop="local"-->
              <!--:text="$t('m.select_img')"-->
              <!--:cropBtn="{ok:'确定','cancel':'取消'}"-->
              <!--cropRatio="3:2"-->
              <!--@imageuploaded="imageuploaded"-->
              <!--:max-file-size="5242880"-->
              <!--:url="imgUpUrl">-->
              <!--</vue-core-image-upload>-->
              <!--<span class="hint">{{$t('m.suggest')}}</span>-->
              <button class="upload-button" @click="queryCoverList">选择封面</button>
            </div>
          </span>
        </div>
        <div class="split"></div>
        <div class="add-introduce">
          <span class="left">{{$t('m.cou_n_course_introduce')}}</span>
          <div class="right">
            <template v-for="(item,index) in introduceList">
              <div class="text-wrapper" v-if="item.isImage===false">
                <textarea class="text" v-model='item.text' name="text" cols="30" rows="10"
                          placeholder="请填写课程的特点，适合人群，是否可以定制等信息，最好是图片和文字结合，介绍越详细越容易吸引学生报名"></textarea>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>
              <div class="img-wrapper" v-if="item.isImage===true">
                <div class="img-left">
                  <img class='showimg' :src="introduceImgUrl(item)" alt="img" width="100" height="100"><input
                  class="input" type="file" accept="image/*" @change="upImg(index,$event)"/>
                </div>
                <img class="img" @click="del(index)" src="./delete.png" alt="delete-button" width="24" height="24">
              </div>

            </template>
            <button class="add" @click="addText">{{$t('m.addtext')}}</button>
            <button class="add" @click="addImage">{{$t('m.addimg')}}</button>
          </div>
        </div>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="newLessonShow=false">取消</button>
          <button class="btn confirm" @click="nextStep">下一步</button>
        </div>
      </div>
    </div>
    <div class="coverpop-mask" v-if="coverShow">
      <div class="coverpop">
        <button class="close-btn" @click="coverShow=false;newLessonShow=true;">
          <img src="./close.png" alt="关闭" width="14" height="14" style="vertical-align: top">
        </button>
        <h2 class="title">选择封面</h2>
        <section class="cover-wrapper">
          <template v-for="(item,index) in coverList" v-if="!isEmpty(coverList)">
            <section class="coverimg-wrapper" @click="selectCover(item)">
              <img :src="imgprefix+item.faceimg" alt="课程封面" width="165" height="110">
              <span class="circle">
                <span class="in-circle" v-if="coverId==item.id"></span>
              </span>
            </section>
          </template>
          <template v-if="isEmpty(coverList)">
            <p class="noresult" style="font-size:16px;color:#333;font-weight:bold;text-align: center">暂无系统课程封面，您可以上传自己的本地图片</p>
          </template>
        </section>
        <section class="btn-wrapper">
          <button class="confirm-btn" @click="confirmCover">确认</button>
          <vue-core-image-upload
            class="upload-button"
            crop="local"
            text="选择本地图片"
            :cropBtn="{ok:'确定','cancel':'取消'}"
            cropRatio="3:2"
            @imageuploaded="imageuploaded"
            :max-file-size="5242880"
            :url="imgUpUrl">
          </vue-core-image-upload>
          <span class="hint">建议上传720*480的图片，大小不超过5M</span>
        </section>
      </div>
    </div>
    <div class="classpop-mask" v-if="newClassShow">
      <div class="classpop">
        <h2 class="title">设置试听班</h2>
        <p class="row">
          <span class="left">上课模式</span>
          <select name="type"
                  id="classmode"
                  class="type-select"
                  v-model="classmode">
            <option disabled selected value="">请选择</option>
            <option v-for="item in classModeList" :value="item.id">{{decodeURIComponent(item.name)}}</option>
          </select>
        </p>
        <p class="row">
          <span class="left">班级名称</span>
          <input type="text" class="input-name" v-model="classname" placeholder="10字以内" maxlength="10">
        </p>
        <p class="row">
          <span class="left">试听原价</span>
          <input
            type="text"
            class="input-price"
            maxlength="5"
            :value="num"
            @keyup="priceChange">
          <span class="text" style="margin-left:8px;">元/小时</span>
        </p>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="newClassShow=false;newLessonShow=true;">上一步</button>
          <button class="btn confirm" @click="createLesson">创建招生</button>
        </div>
      </div>
    </div>
    <router-view @changeLesson="changeLesson"></router-view>

  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import lessonList from 'components/lessonlist/LessonList'
  import VueCoreImageUpload from 'vue-core-image-upload';
  import Vue from 'vue';
  import aboveNav from 'components/abovenav/AboveNav'
  import sideNav from 'components/sidenav/SideNav'
  import {toMinutes} from 'common/js/toMinutes.js';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: '',
        //---------------------新建课程-----------------------//
        newLessonShow: false,
        lessonname: '',
        firstType: [],             //第一大分类
        secondType: [],            //第二大分类
        thirdType: [],             //第三大分类
        selectedOptions: [],      //表示选中的选项
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./cover.png'),
        upurl: '',                //不包含imgprefix,上传的图片url
        index: 0,        //根据上传图片确定index，从而对相应的list[this.index]赋值
        introduceList: [],
        //---------------选择封面------------------//
        coverShow: false,
        coverList: [],
        coverId: null,
        //---------------------新建班级------------------------//
        newClassShow: false,
        classmode: '',             //上传的上课模式
        classname: '',              //上传的班级名称
        startDateValue: '',         //开课日期，停用
        pickerOptions: {            //停用
          disabledDate(time) {
            return time.getTime() < (Date.now() - 3600 * 24 * 1000);
          }
        },
        startTime: null,   //上课时间//停用
        endTime: null,    //停用
        isFalse: false,
        classperiod: '',   //停用
        inputNum: '',
        classModeList: [],       //服务端获取到的上课模式，如1对1、1对2...
        classPeriodList: [],     //服务端获取到的课程周期，如每天上课、隔天上课
        //---------------------课程列表及翻页-----------------------//
        currentPage: 1,
        totalPage: 1,
        lessonList: [],                   //从服务端获取到的课程列表（总）
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //---------------------新建课程-----------------------//
      showCreateLesson(){
        //重置upurl、lessonname、selectedOptions
        this.imgurl = require('./cover.png');
        this.upurl = '';
        this.lessonname = '';
        this.selectedOptions = [];
        this.newLessonShow = true;
        this.introduceList = [];
        this.classmode = '';
        this.classname = '';
        this.inputNum = '';
      },
      changeLesson(lessoninfo){
        for (let i = 0; i < this.lessonList.length; i++) {
          if (lessoninfo.id == this.lessonList[i].id) {
            Vue.set(this.lessonList, i, lessoninfo);
          }
        }
      },
      //将从服务器获取到的数据增加value字段和label字段
      nameOption(obj){
        for (let i = 0; i < obj.length; i++) {
          obj[i].value = obj[i].id;
          obj[i].label = obj[i].name;
        }
      },
      //将created中异步获取的分类列表合并为适合el-cascader的options
      mergeOption: function (first, second, third) {
        //将第三大类插入第二大类中
        for (let i = 0; i < second.length; i++) {
          if (second[i].thirdtypeid == 1) {
            second[i].children = third;
          }
        }
        saveLocal('secondType', this.secondType);
        saveLocal('thirdType', this.thirdType);
        for (let j = 0; j < first.length; j++) {
          first[j].children = [];
          for (let k = 0; k < second.length; k++) {
            if (second[k].parentid == first[j].id) {
              first[j].children.push(second[k]);
            }
          }
        }
        saveLocal('firstType', this.firstType);
      },
      selectCover(item){
        this.coverId = item.id;
        this.imgurl = this.imgprefix + item.faceimg;
        this.upurl = item.faceimg;
      },
      handleCoverChange(){
        this.imgurl = require('./cover.png');
        this.upurl = '';
      },
      confirmCover(){
        if(this.coverId==null){
          this.$message({
            message: '请选择课程封面',
            type: 'warning'
          });
          return;
        }
        this.newLessonShow = true;
        this.coverShow = false;
      },
      queryCoverList(){
        if (this.isEmpty(this.selectedOptions)) {
          this.$message({
            message: '请选择课程分类',
            type: 'warning'
          });
          return;
        }
        let params = {
          c: 'Lesson',
          a: 'QueryCoverSource',
          id: this.id,
          pageno: 1,
          pagesize: 30,
          maintype: this.selectedOptions[0],
          subtype: this.selectedOptions[1]
        };
        if (this.selectedOptions[2]) {
          params.thirdtype = this.selectedOptions[2];
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.coverId=null;
            this.imgprefix = response.imgprefix;
            this.newLessonShow = false;
            this.coverShow = true;
            this.coverList = response.list;
            this.$forceUpdate();
          }
          if(response.code==101){
            this.coverId=null;
            this.coverList = [];
            this.newLessonShow = false;
            this.coverShow = true;
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      //获取课程的分类
      loadLessonType(){
        let lang = loadLocal('language', false);
        let upLang = '';
        if (lang === 'en') {
          upLang = 'en';
        }
        let i = 0;
        //获取第一大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonType',
            lang: upLang,
            parentid: 0
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.firstType = response.list;
            this.nameOption(this.firstType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType, this.thirdType);
            }
          }
        }).catch((err) => {
          this.loadLessonType();
        });

        //获取第二大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonSecondType',
            lang: upLang,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.secondType = response.list;
            this.nameOption(this.secondType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType, this.thirdType);
            }
          }
        }).catch((err) => {
          this.loadLessonType();
        });

        //获取第三大分类
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLessonThirdType',
            lang: upLang,
            thirdtypeid: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.thirdType = response.list;
            this.nameOption(this.thirdType);
            i++;
            if (i === 3) {
              this.mergeOption(this.firstType, this.secondType, this.thirdType);
            }
          }
        }).catch((err) => {
          this.loadLessonType();
        })
      },
      //删除添加文字、添加图片的某一项
      del: function (index) {
        this.introduceList.splice(index, 1);
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。
      },
      //增加文字、图片的相关方法
      addText(){
        let oText = {
          "isImage": false,
          "text": '',
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      addImage(){
        let oText = {
          "isImage": true,
          "image": './addImage.png',
          "width": 0,
          "height": 0,
        };
        this.introduceList.push(oText);
        this.$forceUpdate();
      },
      introduceImgUrl(item){
        if (item.image == './addImage.png') {
          return require('./addImage.png');
        } else {
          return this.imgprefix + item.image;
        }
      },
      upImg: function (index, e) {
        this.index = index;
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let image = input.previousSibling;
          image.src = e.target.result;
        };
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
      },
      uploadComplete: function (evt) {

        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.imgprefix = jsonobj.imgprefix;
        this.$set(this.introduceList[this.index], 'image', jsonobj.image);
        this.$set(this.introduceList[this.index], 'width', jsonobj.imagewidth);
        this.$set(this.introduceList[this.index], 'height', jsonobj.imageheight);
        this.$forceUpdate();

      },
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 111) {
          this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
        } else if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
          this.newLessonShow = true;
          this.coverShow = false;
        }
      },
      //根据当前introduceList的值，返回相应的符合上传需求的数据
      computeUpIntroduceList(list){
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isImage === true) {
              if (list[i].width === 0) {
                continue;
              }
            } else {
              if (list[i].text === '') {
                continue;
              }
            }
            result.push(list[i]);
          }
          if (this.isEmpty(result)) {
            return '';
          }
          result = JSON.stringify(result);
          result = encodeURIComponent(result);
          return result;
        }
      },
      nextStep(){
        if (this.lessonname === '') {
          this.$message({
            message: '请输入课程名称',
            type: 'warning'
          });
          return;
        }
        if (this.isEmpty(this.selectedOptions)) {
          this.$message({
            message: '请选择课程分类',
            type: 'warning'
          });
          return;
        }
        if (this.upurl === '') {
          this.$message({
            message: '请选择课程封面',
            type: 'warning'
          });
          return;
        }
        if (this.computeUpIntroduceList(this.introduceList) === '') {
          this.$message({
            message: '请填写课程介绍',
            type: 'warning'
          });
          return;
        }
        this.newLessonShow = false;
        this.newClassShow = true;
      },
      //获取时间
      getStartDate(time){
        return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
      },
      //获取上课开始时间和上课截止时间
      getTime(time){
        return time.getHours() + ':' + time.getMinutes();
      },
      //获取上课模式名字
      getModeName(classmode, classModeList){
        for (let i = 0; i < classModeList.length; i++) {
          //因为从服务端获取到的为字符串，而classModeList的类型为数字，因此必须使用==，而不是全等
          if (classmode == classModeList[i].id) {
            return decodeURIComponent(classModeList[i].name);
          }
        }
      },
      //新建课程的方法
      createLesson(){
        if (this.classmode === '') {
          this.$message({
            message: '请选择上课模式',
            type: 'warning'
          });
          return;
        }
        if (this.classname === '') {
          this.$message({
            message: '请输入班级名称',
            type: 'warning'
          });
          return;
        }
        if (this.num === '') {
          this.$message({
            message: '请输入试听原价',
            type: 'warning'
          });
          return;
        }
        let typename = '';
        //如何使用axios传入post参数
        //https://jingyan.baidu.com/album/29697b916d6a7bab20de3cf9.html?picindex=3
        let params = new URLSearchParams();
        params.append('id', this.id);
        params.append('rid', this.schoolNow.rid);
        params.append('lessonname', this.lessonname);
        params.append('faceimg', this.upurl);
        params.append('maintype', this.selectedOptions[0]);
        params.append('subtype', this.selectedOptions[1]);
        let introduce = this.computeUpIntroduceList(this.introduceList);
        params.append('introduce', introduce);
        for (let i = 0; i < this.firstType.length; i++) {
          if (this.firstType[i].id == this.selectedOptions[0]) {
            typename = this.firstType[i].name;
          }
        }
        for (let i = 0; i < this.secondType.length; i++) {
          if (this.secondType[i].id == this.selectedOptions[1]) {
            typename += '/' + this.secondType[i].name;
          }
        }
        if (this.selectedOptions.length === 3) {
          params.append('thirdtype', this.selectedOptions[2]);
          for (let i = 0; i < this.thirdType.length; i++) {
            if (this.thirdType[i].id == this.selectedOptions[2]) {
              typename += '/' + this.thirdType[i].name;
            }
          }
        }
        params.append('typename', typename);
        //上课模式（1对1、1对2。。。）
        let modename = this.getModeName(this.classmode, this.classModeList);

        params.append('classmode', this.classmode);
        params.append('classmodename', modename);
        params.append('classname', this.classname);
        params.append('democlass', 1);
        params.append('starttime', "12:00");
        params.append('endtime', "13:00");
        params.append('totalnumber', 1);


        params.append('unitprice', this.num);
        params.append('totalprice', this.num);
        params.append('actualprice', 0);
        params.append('ispublish', 1);
        //接口：指定用户新建课程
        this.$http({
          url: '/indexapp.php?c=Lesson&a=AddLessonClass',
          method: 'post',
          data: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.newClassShow = false;
            this.$alert(response.msg, '创建成功', {
              confirmButtonText: '好的',
            });
            this.loadLessonList(1);
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        })
      },
      //-----------------班级的方法--------------------------------//
      priceChange(e) {
        this.inputNum = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      //---------------------课程列表及翻页-----------------------//
      //当页面发生改变时
      handleCurrentChange(val) {
        this.loadLessonList(val);
      },
      //根据传入的数字，获取相应的课程列表
      loadLessonList(page){
        //接口：查询指定用户课程列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLesson',
            id: this.id,                //sessionid
            queryrid: this.schoolNow.rid,              //网校id
            pageno: page,
            pagesize: 8,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.lessonList = response.list;
            this.totalPage = response.recordcount;
          }

        }).catch((err) => {
          this.loadLessonList(page)
        })
      },
      //获取上课模式列表
      loadClassModeList(){
        let lang = loadLocal('language', false);
        let upLang = '';
        if (lang === 'en') {
          upLang = 'en';
        }
        //接口：返回开班模式列表（id不是必须值）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCatalog',
            a: 'QueryClassModeList',
            // lang: upLang,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.classModeList = response.list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
    },
    computed: {
      num() {
        return this.inputNum.replace(/[^\d.]/g, "") //清除‘数字’和‘.’以外的字符
          .replace(/^\./g, "")              //验证第一个字符是数字而不是.
          .replace(/\.{2,}/g, ".")          //只保留第一个.清除多余的.
          .replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      },
    },
    created(){
      //裁切图片上传的地址
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
      //请求课程列表
      this.loadLessonList(1);
      //请求课程分类
      this.loadLessonType();
      //请求班级类型，如1对1
      this.loadClassModeList();

      let open = decodeURIComponent(this.$utils.getUrlKey('open'));
      if (open === 'true') {
        this.showCreateLesson();
      }

    },
    components: {
      lessonList,
      VueCoreImageUpload,
      sideNav,
      aboveNav,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .lesson
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .top-nav
      position fixed
      left: 160px
      top: 40px
      right: 0
      height: 50px
      background #ffffff
      border-bottom: 1px solid #e4e4e4
      .new-lesson
        margin: 8px 0 0 20px
        padding: 0 10px
        height: 34px
        line-height: 34px
        text-align: center
        font-size: 15px
        color: #ffffff
        background #3399ff
        border-radius 4px
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
    .lessonpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .lessonpop
        margin: auto
        width: 1005px
        padding-left: 80px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          padding: 30px 0 50px
          line-height: 38px
          font-size: 28px
          color: #333333
          font-weight: bold
          .close
            float: right
            margin-right: 75px
            cursor pointer
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .input-name
            width: 350px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
            .upload-button-wrapper
              height: 30px
              margin-top: 10px
              padding-left: 10px
              .upload-button
                display: inline-block
                margin-right: 10px
                height: 30px
                line-height: 30px
                width: 90px
                text-align: center
                background: #f2f2f2
                color: #666
                font-size: 13px
                border: 1px solid #d7d7d7
                border-radius: 4px
                box-sizing border-box
                vertical-align: top
                cursor: pointer
              .hint
                display: inline-block
                padding: 0 10px
                height: 28px
                line-height: 28px
                text-align: center
                font-size: 12px
                color: #999999
                border-radius: 4px
                border: 1px solid #ffb76e
                background: #fff9e7

        .split
          margin-bottom: 20px
          height: 10px
          width: 845px
          border-bottom: 2px dashed #d7d7d7
        .add-introduce
          width: 880px
          overflow hidden
          .left
            float: left
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .right
            float: left
            width: 795px
            .text-wrapper
              display: flex
              align-items center
              margin-bottom: 10px
              .text
                padding: 10px
                width: 760px
                height: 100px
                font-size: 15px
                color: #000
                box-sizing border-box
                border-radius 4px
                border: 1px solid #d7d7d7
                line-height: 20px
                resize: none
              .img
                margin-left: 10px
                cursor pointer

            .img-wrapper
              display: flex
              align-items center
              justify-content space-between
              margin-bottom: 10px
              .img-left
                width: 760px
                height: 100px
                position relative
                .input
                  position: absolute
                  left: 0
                  top: 0
                  height: 100px
                  width: 100px
                  padding: 0
                  margin: 0
                  opacity: 0

            .add
              margin-right: 10px
              height: 34px
              line-height: 34px
              width: 80px
              font-size: 14px
              color: #555555
              border: 1px solid #d7d7d7
              box-sizing border-box
              border-radius 4px

        .operate-btn-wrapper
          margin: 70px 0 30px 50px
          .btn
            margin-right: 65px
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            background #ccc
          .confirm
            background #3399ff

    .coverpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .coverpop
        margin: auto
        padding-bottom: 16px
        width: 752px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position: relative
        .close-btn
          position: absolute
          top: 0
          right: 0
          display: block
          width: 34px
          height: 34px

        .title
          height: 34px
          line-height: 34px
          padding-left: 22px
          font-size: 14px
          color: #333333
          background: #f3f3f3
        .cover-wrapper
          padding: 22px 22px 52px
          background: #fff
          .coverimg-wrapper
            display: inline-block
            margin: 0 16px 16px 0
            width: 165px
            height: 110px
            position: relative
            &:nth-child(4n)
              margin-right: 0
            .circle
              position: absolute
              top: 8px
              left: 8px
              display: inline-block
              width: 12px
              height: 12px
              border-radius: 6px
              background: rgba(255, 255, 255, 0.5)
              .in-circle
                position: absolute
                top: 2px
                left: 2px
                display: inline-block
                width: 8px
                height: 8px
                border-radius: 4px
                background: #3399ff
        .btn-wrapper
          padding: 8px 22px
          background: #f3f3f3
          height: 34px
          .confirm-btn
            height: 34px
            line-height: 34px
            width: 120px
            text-align: center
            border-radius: 4px
            background: #3399ff
            font-size: 14px
            color: #fff
          .upload-button
            display: inline-block
            margin-left: 20px
            height: 34px
            line-height: 34px
            width: 120px
            text-align: center
            background: #fff
            color: #666
            font-size: 14px
            border: 1px solid #666
            border-radius: 4px
            box-sizing border-box
            vertical-align: top
            cursor: pointer
          .hint
            margin-left: 10px
            display: inline-block
            font-size: 14px
            height: 34px
            line-height: 34px
            color: #666
    .classpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .classpop
        margin: auto
        width: 1005px
        padding-left: 80px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          padding: 30px 0 50px
          line-height: 38px
          font-size: 28px
          color: #333333
          font-weight: bold
          .close
            float: right
            margin-right: 75px
            cursor pointer
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .type-select
            width: 105px
            font-size: 14px
            color: #000
            border: 1px solid #e4e4e4
            height: 35px
            -webkit-appearance: none
            -moz-appearance: none
            appearance: none
            background: #fff url('down.png') no-repeat right 9px center
            background-size: 12px 12px
            padding: 0 30px 0 6px
            border-radius: 4px
            box-sizing: border-box
            &.disable
              background: #f5f7fa
              cursor: not-allowed
          .input-name
            width: 280px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
          .input-price
            padding-left: 6px
            width: 80px
            height: 35px
            font-size: 15px
            color: #000
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
            &.disable
              background: #f5f7fa
              cursor: not-allowed
          .text
            display: inline-block
            height: 35px
            line-height: 35px
            font-size: 15px
            color: #888
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
        .operate-btn-wrapper
          margin: 40px 0 30px 50px
          .btn
            margin-right: 65px
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            background #fff
            color: #3399ff
          .confirm
            background #3399ff

        .introduce-wrapper
          overflow hidden
          .left
            float: left
            width: 75px
            line-height: 35px
            font-size: 15px
            color: #888888
          .introduce
            float: left
            width: 760px
            margin-left: 10px
            padding-top: 5px
            img
              margin-bottom: 5px
            .text
              /*<pre>标签让<textarea>标签的内容原样输出http://www.cnblogs.com/mizzle/p/3874802.html*/
              margin-bottom: 5px
              padding: 0
              font-size: 15px
              text-align: left
              line-height: 24px
              color: #000
              width: 760px
              white-space: pre-wrap
              word-wrap: break-word
              word-break: break-all
</style>



// WEBPACK FOOTER //
// src/page/lesson/Lesson.vue